import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";
import { ViewVariant } from "@/common/ts/layout";

import GeneralStatusHistoryView, {
  GeneralStatusHistoryViewProps,
} from "./GeneralStatusHistoryView";

interface Props extends AppModalProps {
  viewProps: GeneralStatusHistoryViewProps;
}

export default function GeneralStatusHistoryViewModal({ viewProps, ...modalProps }: Props) {
  const openStatus = useModalOpenStatus(modalProps);

  return (
    <AppModal fullWidth maxWidth='lg' {...modalProps}>
      <AppModalContent>
        {openStatus.isOpen && (
          <GeneralStatusHistoryView
            headerProps={{
              withLink: true,
              typographyProps: {
                variant: "h1",
              },
            }}
            {...viewProps}
            displayProps={{
              // viewVariant: ViewLayoutVariant.Tab, // TODO: must be Modal
              viewVariant: ViewVariant.Modal,
              closeInHeader: true,
              ...viewProps?.displayProps,
            }}
            onDeleted={() => {
              modalProps.onClose && modalProps.onClose({}, "escapeKeyDown");
            }}
            onClose={() => {
              modalProps.onClose && modalProps.onClose({}, "backdropClick");
              viewProps.onClose && viewProps.onClose();
            }}
          />
        )}
      </AppModalContent>
    </AppModal>
  );
}
